export const generateSignifydSessionId = /* GraphQL */ `
    mutation generateSignifydSessionId($cart_id: String!) {
        generateSignifydSessionId(cart_id: $cart_id) {
            data_order_session_id
        }
    }
`
